import React, { PureComponent } from 'react';
import _ from 'lodash';

import { PopOver, OverlayTrigger, Button } from '@tencent/spaui';

class Step extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!(this.props.positionTarget || this.props.getTarget())) {
      if (_.isFunction(this.props.onNext)) {
        this.props.onNext();
      }
    }
    if (_.isFunction(this.props.onMount)) {
      this.props.onMount();
      this.forceUpdate();
    }
  }
  componentWillUnmount() {
    if (_.isFunction(this.props.onUnmount)) {
      this.props.onUnmount();
    }
  }

  stopPropagation = (event) => {
    event.stopPropagation();
  };

  onButtonClick = (event) => {
    if (_.isFunction(this.props.onNext)) {
      this.props.onNext(event);
    }
    if (_.isFunction(this.props.onClose)) {
      this.props.onClose(event);
    }
  };

  render() {
    if (!(this.props.positionTarget || this.props.getTarget())) {
      return null;
    }
    const overlay = (
      <PopOver
        className={this.props.className || 'dark a-guide-popover popover-right'}
        onClick={this.stopPropagation}
        arrowStyle={this.props.arrowStyle}
      >
        {this.props.title ? (
          <h4 className="spaui-popover-title" onClick={this.stopPropagation}>
            {this.props.title}
          </h4>
        ) : null}
        {this.props.desc ? (
          <div className="spaui-popover-body" onClick={this.stopPropagation}>
            {this.props.desc}
          </div>
        ) : null}
        {this.props.nextLabel ? (
          <div className="spaui-popover-footer" onClick={this.stopPropagation}>
            {this.props.hideSkip ? null : (
              <button className="popover-right__next" onClick={this.props.onSkip}>
                跳过
              </button>
            )}
            <Button bsSize="small" bsStyle="primary" onClick={this.onButtonClick}>
              {this.props.nextLabel}
            </Button>
          </div>
        ) : null}
      </PopOver>
    );
    return (
      <OverlayTrigger
        placement={this.props.placement}
        show={this.props.show}
        overlay={overlay}
        triggerTarget={this.props.positionTarget || this.props.getTarget()}
        offsetData={this.props.offsetData || (_.isFunction(this.props.getOffsetData) ? this.props.getOffsetData() : {})}
        alignment={this.props.alignment ? this.props.alignment : 'center'}
      />
    );
  }
}

Step.defaultProps = {
  getTarget: _.noop,
  onNext: _.noop,
  show: true,
};

export default Step;
